<template>
  <div>
    <div class="qdMenumobile"
      style="width: 100vw; margin: 0 auto;padding: 0.2rem 0 0.2rem 0.15rem;box-sizing: border-box;">
      <div style="
          display: flex;
          align-items: center;
          justify-content:space-between;
          height: 0.3625rem;
          width: 100%;
        ">
        <div style="flex: 1;">
          <div class="menu5" style="width: 100%;display: flex;justify-content: flex-start;">
            <el-popover placement="bottom-start" width="400" @show="showPop" @hide="hidePop" trigger="click"
              popper-class="yyxxPopmobile">
              <div style="font-size: 0.15rem; color: #fff;line-height: 0.25rem;">
                <div style="width: 100%;">开馆时间：</div>
                <div style="margin-bottom: 0;width: 100%;" v-if="contentInfo.openCloseTime">
                  {{ contentInfo.openCloseTime.slice(0, 5) }} -
                  {{ contentInfo.openCloseTime.slice(10, 16) }}
                </div>
                <div style="width: 100%;">闭馆时间：</div>
                <div style="width: 100%;">
                  [{{ contentInfo.wicketHint }}]</div>
              </div>
              <el-button slot="reference" class="yyxxSty">营业信息
                <i class="el-icon-caret-bottom" v-if="!yyxxShow"></i>
                <i class="el-icon-caret-top" v-if="yyxxShow"></i>
              </el-button>
            </el-popover>
          </div>
        </div>
        <div>
          <van-popover v-model="showPopover" trigger="click" placement="bottom-end">
            <div class="popDiagTxt" :style="{background:(activeIndex==index)?'#2B2D33':''}"
              v-for="(item,index) in titList1" :key="index" @click='toRouter(item.src)'>
              <!--              <router-link :to="item.src">

              </router-link> -->
              <div style="display: flex;align-items: center;margin-right: 0.1625rem;"><img :src="item.img"
                  style="width: 0.2125rem;height: auto;"></img></div>
              <div style="flex: 1;text-align: left;">{{item.tit}}</div>
              <div>
                <van-icon name="arrow" />
              </div>
            </div>
            <template #reference>
              <div style="padding-right: 0.15rem;">
                <img src="./image/moreMenu.png" style="width: 0.225rem;height: 0.1875rem"></img>
              </div>
            </template>
          </van-popover>
        </div>
      </div>
    </div>
    <!-- <van-popup v-model:show="activemobile" position="top" :style="{ height: '100%' }" >
      <transition name="fade">
        <div class="popDiag">
          <div class="popDiagTxt" v-for="(item,index) in titList1" :key="index" @click='toDetail1'>
            <router-link :to="item.src">{{item.tit}}</router-link>
          </div>
         <van-collapse v-model="activeNames" accordion>
           <van-collapse-item :title="item.tit" :name="index" v-for="(item,index) in titList" :key="index">
              <div v-for="(item1,index1) in item.children" :key="index1" v-if="item.children" class="popDiagsubtit" @click='toDetail(item1.src,item1.id)'>
                 <span v-if="item1.id!=3">{{item1.tit}}</span>
                 <a :href="link" v-if="item1.id==3" rel="nofollow">{{item1.tit}}</a>
              </div>
           </van-collapse-item>
          </van-collapse>
        </div>
      </transition>
    </van-popup> -->
  </div>
</template>

<script>
  import Cookies from "js-cookie";
  import {
    getMe
  } from "@/api/login.js";
  import {
    logout
  } from "@/api/login.js";
  import {
    getInfo
  } from "@/api/index/index.js";
  export default {
    name: "app",
    data() {
      return {
        showPopover: false,
        link: 'http://222.184.82.226:83/signup',
        titList1: [{
            id: 1,
            tit: '首页',
            src: '/mIndex',
            img: require('./image/imgp1.png')
          },
          {
            id: 2,
            tit: '场馆概况',
            src: '/moverview/overviewInfo',
            img: require('./image/imgp2.png')
          },
          {
            id: 3,
            tit: '展览导航',
            src: '/mnavigation/navigationInfo',
            img: require('./image/imgp3.png')
          },
          {
            id: 4,
            tit: '科普知识',
            src: '/mknowledge/knowList',
            img: require('./image/imgp4.png')
          },
          {
            id: 5,
            tit: '信息资讯',
            src: '/minformation/infoList',
            img: require('./image/imgp5.png')
          },
          {
            id: 6,
            tit: '服务资讯',
            src: '/mconsult/consultInfo',
            img: require('./image/imgp6.png')
          },
          {
            id: 7,
            tit: '展教活动',
            src: '/meduActivity/meduList',
            img: require('./image/imgp7.png')
          },
        ],
        titList: [{
          id: 7,
          tit: '联系我们',
          children: [{
              id: 71,
              tit: '联系我们',
              src: '/mcontact',
              id: 1
            },
            {
              id: 71,
              tit: '招贤纳士',
              src: '/mcontact',
              id: 2
            },
            {
              id: 71,
              tit: '供应商',
              src: '/mcontact',
              id: 3
            },
          ]
        }, ],
        contentInfo: {},
        imageUrl: "1",
        activeIndex: 0,
        yyxxShow: 0,
        route: "/",
        searchName: "",
        showMenu: true,
        searchShow: false,
        input3: "",
        zhShow: 1,
        lang: "zh",
        src: "PersonInfo",
        src1: "Account",
        userAllInfo: {},
        menuList: [{
            id: 1,
            name: "首页",
            ywname: "FRONT PAGE",
            src: "Index",
            child: [],
            route: "/",
          },
          {
            id: 2,
            name: "科技馆概况",
            ywname: "OVERVIEW",
            src: "Overview",
            route: "/overview/overviewInfo",
            child: [{
                id: 21,
                name: "场馆介绍",
                src: "Overview"
              },
              {
                id: 22,
                name: "机构设置",
                src: "Overview"
              },
              {
                id: 23,
                name: "大事记",
                src: "Overview"
              },
            ],
          },
          {
            id: 3,
            name: "展览导航",
            ywname: "EXHIBITION",
            src: "Navigation",
            route: "/navigation/navigationInfo",
            child: [{
                id: 21,
                name: "临时展览",
                src: "Navigation",
                href: "#navigatepage1",
              },
              {
                id: 22,
                name: "常设展览",
                src: "Navigation",
                href: "#navigatepage2",
              },
              {
                id: 22,
                name: "特展回眸",
                src: "Navigation",
                href: "#navigatepage3",
              },
            ],
          },
          {
            id: 4,
            name: "科普知识",
            ywname: "POPULAR SCIENCE",
            src: "Knowledge",
            route: "/knowledge/knowList",
            child: [{
                id: 21,
                name: "科技精粹",
                src: "Knowledge"
              },
              {
                id: 22,
                name: "展项原理",
                src: "Knowledge"
              },
            ],
          },
          {
            id: 5,
            name: "信息资讯",
            ywname: "INFORMATION",
            src: "Information",
            route: "/information/infoList",
            child: [],
          },
          {
            id: 6,
            name: "服务咨询",
            ywname: "CONSULTING",
            src: "Consult",
            route: "/consult/consultInfo",
            child: [{
                id: 21,
                name: "参观预约",
                src: "Consult"
              },
              {
                id: 22,
                name: "问卷调查",
                src: "Consult"
              },
              {
                id: 21,
                name: "参观须知",
                src: "Consult"
              },
              {
                id: 22,
                name: "服务设施",
                src: "Consult"
              },
              {
                id: 22,
                name: "留言板",
                src: "Consult"
              },
            ],
          },
          {
            id: 7,
            name: "展教活动",
            ywname: "ACTIVITIES",
            src: "EduInform",
            route: "/eduActivity/eduInfo",
            child: [{
                id: 21,
                name: "教育活动",
                src: "EduInform"
              },
              {
                id: 22,
                name: "培训班",
                src: "EduActivity"
              },
              {
                id: 21,
                name: "热门展项",
                src: "EduActivity"
              },
            ],
          },
          {
            id: 8,
            name: "特效影院",
            ywname: "CINEMA",
            src: "Cinema",
            route: "/cinema/inform",
            child: [],
          },
        ],
        options: [{
            value: "0",
            label: "营业信息",
          },
          {
            value: "1",
            label: "ENGLISH",
          },
          {
            value: "2",
            label: "日本語",
          },
          {
            value: "3",
            label: "한국어",
          },
        ],
        value: "",
      };
    },

    computed: {
      // menuList() {
      //     return [
      //   {id:1,name:this.$t("m['首页']"),src:'Home',child:[]},
      //   {id:2,name:this.$t("m['场馆概况']"),src:'Overview',child:[
      //     {id:21,name:this.$t("m['场馆介绍']"),src:'Overview'},
      //     {id:22,name:this.$t("m['机构设置']"),src:'Overview'},
      //     {id:23,name:this.$t("m['大事记']"),src:'Overview'},
      //   ]},
      //   {id:3,name:this.$t("m['展览导航']"),src:'Navigation',child:[
      //     {id:21,name:this.$t("m['临时展览']"),src:'Navigation'},
      //     {id:22,name:this.$t("m['常设展览']"),src:'Navigation'},
      //   ]},
      //   {id:4,name:this.$t("m['科普知识']"),src:'Knowledge',child:[
      //     {id:21,name:this.$t("m['科技精粹']"),src:'Knowledge'},
      //     {id:22,name:this.$t("m['展项原理']"),src:'Knowledge'},
      //   ]},
      //   {id:5,name:this.$t("m['信息资讯']"),src:'Information',child:[]},
      //   {id:6,name:this.$t("m['服务咨询']"),src:'Consult',child:[
      //     {id:21,name:this.$t("m['参观预约']"),src:'Consult'},
      //     {id:22,name:this.$t("m['问卷调查']"),src:'Consult'},
      //     {id:21,name:this.$t("m['参观须知']"),src:'Consult'},
      //     {id:22,name:this.$t("m['服务设施']"),src:'Consult'},
      //     {id:22,name:this.$t("m['留言板']"),src:'Consult'},
      //   ]},
      //   {id:7,name:this.$t("m['展教活动']"),src:'EduActivity',child:[
      //     {id:21,name:this.$t("m['教育活动']"),src:'EduActivity'},
      //     {id:22,name:this.$t("m['培训班']"),src:'EduActivity'},
      //     {id:21,name:this.$t("m['热门展项']"),src:'EduActivity'},
      //   ]},
      //   {id:8,name:this.$t("m['特效影院']"),src:'Cinema',child:[]},
      // ]
      // }
    },
    props: ["active"],
    methods: {
      toRouter(src) {
        if(src=='/meduActivity/meduList'){
          this.$toast({
            message:'小程序暂未上线,请耐心等待'
          })
        }else{
          this.$router.push(src)
        }

      },
      toDetail(src, id) {
        if (id) {
          if (id != 3) {
            this.$router.push({
              path: src,
              query: {
                id: id
              }
            })
          }
        }
        this.$emit('activeChange', 0)
      },
      toDetail1() {
        this.$emit('activeChange', 0)
      },
      //内容管理
      getInfo() {
        getInfo().then((res) => {
          if (res.data.code == 0) {
            this.contentInfo = res.data.contenfronpageManage;
          } else {
            // this.$message({
            //   message: res.data.msg,
            //   type: 'warning'
            // });
          }
        });
      },
      toClick(item, index) {
        if (item.id == 7 || item.id == 8) {
          if (Cookies.get("userInfoqd")) {
            if (!JSON.parse(Cookies.get("userInfoqd")).token) {
              this.$message.success("请先登录再操作");
              // setTimeout(()=>{
              this.$router.push("/login");
              // },1000)
            } else {
              this.activeIndex = index;
              this.$router.push({
                name: item.src
              });
            }
          } else {
            this.$message.success("请先登录再操作");
            // setTimeout(()=>{
            this.$router.push("/login");
            // },1000)
          }
        } else {
          this.activeIndex = index;
          this.$router.push({
            name: item.src
          });
        }
      },
      showPop() {
        this.yyxxShow = 1;
      },
      hidePop() {
        this.yyxxShow = 0;
      },
      toLoginValide(item) {
        if (item.id == 7 || item.id == 8) {
          if (Cookies.get("userInfoqd")) {
            if (!JSON.parse(Cookies.get("userInfoqd")).token) {
              this.$message.success("请先登录再操作");
              // setTimeout(()=>{
              this.$router.push("/login");
              // },1000)
            } else {
              // getMe().then(res=>{
              //   if(res.data.code=='0'){
              //   }else if(res.data.code=='403'){
              //     this.$message.success('请先登录再操作')
              //     // setTimeout(()=>{
              //       this.$router.push('/login')
              //     // },1000)
              //     Cookies.remove('userInfo')
              //     Cookies.remove('userAllInfo')
              //   }else{
              //     this.$message.success('请先登录再操作')
              //     // setTimeout(()=>{
              //       this.$router.push('/login')
              //     // },1000)
              //     Cookies.remove('userInfo')
              //     Cookies.remove('userAllInfo')
              //   }
              // })
            }
          } else {
            this.$message.success("请先登录再操作");
            // setTimeout(()=>{
            this.$router.push("/login");
            // },1000)
          }
        }
      },
      toLoginValide1(item, item1, index1) {
        if (item.id == 7) {
          if (Cookies.get("userInfoqd")) {
            if (!JSON.parse(Cookies.get("userInfoqd")).token) {
              this.$message.success("请先登录再操作");
              // setTimeout(()=>{
              this.$router.push("/login");
              // },1000)
            } else {
              // getMe().then(res=>{
              //   if(res.data.code=='0'){
              this.$router.push({
                name: item1.src,
                query: {
                  id: parseInt(index1) + 1,
                  time: new Date().getTime()
                },
              });
              //   }else if(res.data.code=='403'){
              //     Cookies.remove('userInfo')
              //     Cookies.remove('userAllInfo')
              //     this.$message.success('请先登录再操作')
              //     // setTimeout(()=>{
              //       this.$router.push('/login')
              //     // },1000)
              //   }else{
              //     Cookies.remove('userInfo')
              //     Cookies.remove('userAllInfo')
              //     this.$message.success('请先登录再操作')
              //     // setTimeout(()=>{
              //       this.$router.push('/login')
              //     // },1000)
              //   }
              // })
            }
          } else {
            this.$message.success("请先登录再操作");
            // setTimeout(()=>{
            this.$router.push("/login");
            // },1000)
          }
        } else {
          this.$router.push({
            name: item1.src,
            query: {
              id: parseInt(index1) + 1,
              time: new Date().getTime()
            },
          });
        }
      },
      getMe() {
        getMe({}).then((res) => {
          if (res.data.code == 0) {
			var reg=/http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
			if(!reg.test(res.data.me.image)){
				this.imageUrl = res.data.me.image ?
				  process.env.VUE_APP_IMG_URL + res.data.me.image :
				  require("./image/avatar.png");
			}else{
				this.imageUrl = res.data.me.image ?
				  res.data.me.image :
				  require("./image/avatar.png");
				
			}

          }
        });
      },
      tosearchShow() {
        this.searchShow = !this.searchShow;
        this.searchName = "";
      },
      logout() {
        logout().then((res) => {
          if (res.data.code == 0) {
            this.zhShow = 2;
            this.$forceUpdate()
            // localStorage.clear();
            Cookies.remove("userInfoqd");
            Cookies.remove("userAllInfoqd");
            Object.keys(localStorage).forEach((item) => {
              if (item != "count") {
                localStorage.removeItem(item);
              }
            });
            if (this.zhShow) {
              this.$router.push({
                name: 'Index',
                query: {
                  time1: new Date().getTime()
                }
              });
            }
          }
        });
      },
      toSearch() {
        this.$router.push({
          name: "Search",
          query: {
            name: this.searchName
          }
        });
      },
      pClick(item) {},
      change(val) {
        // 中文
        if (val == 0) {
          // this.lang="zh";
          // localStorage.setItem("locale",this.lang)
          // this.$i18n.locale = this.lang;
          // 英文
        } else if (val == 1) {
          var p = window.location.protocol;
          var a = document.createElement("a");
          a.setAttribute("href", `http://192.168.28.139:8082`);
          a.setAttribute("target", "_blank");
          a.click();
          document.getElementsByTagName("body")[0].appendChild(a);

          // this.lang='en';
          // localStorage.setItem("locale",this.lang)
          // this.$i18n.locale = this.lang;
          //日文
        } else if (val == 2) {
          // this.lang="ja";
          // localStorage.setItem("locale",this.lang)
          // this.$i18n.locale = this.lang;
          //韩文
        } else if (val == 3) {
          // this.lang="ko";
          // localStorage.setItem("locale",this.lang)
          // this.$i18n.locale = this.lang;
        }
      },
      toLogin(id) {
        this.$router.push({
          name: "Login"
        });
        // if(id==1){
        //   this.$router.push({name:'Password'})
        // }else{
        //   this.$router.push({name:'Login'})
        // }
      },
      // beforeunloadHandler(e) {    //根据事件进行操作进行操作
      //   getMe().then(res=>{
      //     if(res.data.code=='0'){
      //       this.zhShow=0
      //     }else if(res.data.code=='403'){
      //       this.zhShow=1
      //       localStorage.removeItem('userInfo')
      //       localStorage.removeItem('userAllInfo')
      //     }else{
      //       this.zhShow=1
      //       localStorage.removeItem('userInfo')
      //       localStorage.removeItem('userAllInfo')
      //     }
      //   })
      // },
    },
    // destroyed () {  //进行监听销毁
    //     window.removeEventListener('beforeunload', e =>this.beforeunloadHandler(e))
    // },
    mounted() {
      if (Cookies.get("userInfoqd")) {
        if (!JSON.parse(Cookies.get("userInfoqd")).token) {
          this.zhShow = 1;
        } else {
          this.zhShow = 0;
          // window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))   //监听页面刷新触发事件
        }
      } else {
        this.zhShow = 1;
      }
      this.route = this.$route.path;
    },
    created() {
      this.getInfo();

      if (Cookies.get("userInfoqd")) {
        this.userAllInfo = JSON.parse(Cookies.get("userInfoqd"));
        this.getMe();
      }
    },
    watch: {
      "$route.query.time": {
        handler: function(val, oldVal) {
          if (val) {
            this.getMe()
          } else {}
        },
        immediate: true,
        // 深度观察监听
        deep: true,
      },
      // "$route.query.time1": {
      //   handler: function (val, oldVal) {
      //       if (Cookies.get("userInfoqd")) {
      //         if (!JSON.parse(Cookies.get("userInfoqd")).token) {
      //           this.zhShow = 1;
      //         } else {
      //           this.zhShow = 0;
      //           // window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))   //监听页面刷新触发事件
      //         }
      //       } else {
      //         this.zhShow = 1;
      //       }
      //       alert(this.zhShow)
      //   },
      //   immediate: true,
      //   // 深度观察监听
      //   deep: true,
      // },
      "$route.path": {
        handler: function(val, oldVal) {
          if (val) {
            if (val.split("/")) {
              if (val.split("/")[1] == "mIndex") {
                this.activeIndex = 0;
              } else if (val.split("/")[1] == "moverview") {
                this.activeIndex = 1;
              } else if (val.split("/")[1] == "mnavigation") {
                this.activeIndex = 2;
              } else if (val.split("/")[1] == "mknowledge") {
                this.activeIndex = 3;
              } else if (val.split("/")[1] == "minformation") {
                this.activeIndex = 4;
              } else if (val.split("/")[1] == "mconsult") {
                this.activeIndex = 5;
              } else if (val.split("/")[1] == "meduActivity") {
                this.activeIndex = 6;
              } else {
                this.activeIndex = null;
              }
            }
          } else {
            this.activeIndex = null;
          }

        },
        immediate: true,
        // 深度观察监听
        deep: true,
      },
      zhShow: {
        handler(val, oldVal) {
          this.zhShow = val;
        },
        immediate: true,
        deep: true,
      },
    },
  };
</script>
<style>
  .van-toast{
    z-index: 70000!important;
    white-space: nowrap;
  }
  .yyxxPopmobile.el-popper {
    /* left: 0 !important; */
    min-width: auto !important;
    width: 1.3rem !important;
    /* height: 1.125rem!important; */
    background: #353f55;
    border-radius: 0.125rem;
    border: 2px solid #36b8cf;
    margin-top: 0.0625rem !important;
    padding: 0.125rem 0.075rem !important;
    /* font-size: 0.125rem; */
    /* transform: scale(0.83333); */
    box-sizing: border-box;
  }

  .yyxxPopmobile.el-popper .popper__arrow {
    display: none;
  }

  .van-popover[data-popper-placement=bottom-end] .van-popover__arrow {
    display: none;
  }

  .van-popover--light {
    top: 0.875rem !important;
    z-index: 7000 !important;
  }

  .van-popover__content {
    border-radius: 0 !important;
  }
</style>
<style lang="less" scoped>
  .qdMenumobile {
    .activeStys {
      border-top: 0.0375rem solid #54edff;
    }

    .yyxxSty.el-button {
      padding: 0;
      background-image: url(./image/yyxx.png);
      width: 1.2rem;
      height: 0.5rem;
      line-height: 0.54rem;
      // transform: scale(0.75);
      transform-origin: left center;
      background-size: 100% 100%;
      background-color: transparent;
      border: none;
      font-size: 0.15rem;
      color: #fff;
      text-align: center;
    }

    /deep/ .el-input__inner {
      background-image: url(./image/yyxx.png);
      width: 1.6875rem;
      height: 0.625rem;
      background-size: 100% 100%;
      background-color: transparent;
      border: none;
      font-size: 0.2rem;
      color: #fff;
      text-align: center;
    }

    /deep/ .el-input__suffix {
      right: 0.17rem;
    }

    /deep/ .el-input__icon {
      line-height: 0.4375rem;
    }

    /deep/ .el-input__suffix-inner {}
  }

  .menu-container {
    font-size: 0.1875rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #f2f2f2;
    // line-height: 0.3rem;
    width: 100%;
    height: 100%;
    padding-left: 0.25rem;
    box-sizing: border-box;
    display: flex;
    // justify-content: space-evenly;
    position: relative;
    box-sizing: border-box;

    li {
      position: relative;
      list-style: none;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      // line-height: 0.4875rem
      z-index: 10;
      height: 100%;
      width: 1.6375rem;
      display: inline-block;
      box-sizing: border-box;

      // visibility: visible;
      // &:hover a + .ul-child >ul> .li-child {
      //   visibility: visible;
      //   transition: all 0.25s linear;
      //   height: 0.625rem;
      //   line-height: 0.625rem;
      //   // animation: moveFromTop 0.3s ease-in-out
      // }
      &:hover a+.ul-child {
        visibility: visible;
        transition: all 0.25s linear;
        // height: 0.625rem;
        line-height: 0.625rem;
        // animation: moveFromTop 0.3s ease-in-out
      }

      a {
        text-decoration: none;
        outline: none;
        font-size: 0.225rem;
        color: rgba(255, 255, 255, 0.7);
        // height: 0.5rem;
        // line-height: 0.5rem;
        box-sizing: border-box;
        word-break: break-all;
        // border-bottom: 4px solid transparent;

        &:hover+.ul-child>.li-child:nth-child(1) {
          // border-top: 4px solid red;
        }
      }

      .ul-child {
        position: absolute;
        width: 1.6375rem;
        // background: #cccccc;
        // top: 0.375rem;
        top: 1.125rem;
        // height: 1.25rem;
        justify-content: center;
        // padding-top: 1.125rem;
        visibility: hidden;
        // visibility:visible;
        box-shadow: 0 0 0.0625rem #00000020 !important;
        box-sizing: border-box;

        .li-child {
          width: 1.6375rem;
          height: 0.625rem;
          line-height: 0.625rem;
          display: flex;
          align-items: center;
          text-align: center;
          cursor: pointer;
          padding: 0.1rem 0.05rem;
          // border-top: 0.05rem solid transparent;
          box-sizing: border-box;
          background: #fff;
          color: #000;

          // border-bottom: 1px solid rgb(207, 21, 45);
          // border-bottom: 1px solid transparent;
          a {
            color: #000;
          }

          &::after {
            // content: url("../assets/home/arrow.png");
            padding: 0 0 0.05rem 0.175rem;
          }

          //   max-height: 0;
          &:not(:last-child) {
            // color:red;
            border-bottom: 1px solid white;
          }

          &:last-child {
            border-bottom-left-radius: 0.0625rem;
            border-bottom-right-radius: 0.0625rem;
          }

          &:hover {
            color: #e7534d;
            background: #fff;

            // border-bottom: 1px solid #FFF;
            a {
              color: #e7534d;
            }

            &::after {
              // content: url("../assets/home/company.png");
              padding: 0 0 0.05rem 0.175rem;
            }
          }
        }
      }
    }

    li:first-child {
      width: 1.3rem;
    }

    li:hover {
      a {
        color: #ce0e2b;
      }
    }
  }

  a.ulAsty {
    display: inline-block;
    width: 100%;
    height: 100%;
  }

  a.ulAstyActive {
    color: rgb(255, 255, 255) !important;
  }

  .menu2 {
    flex: 1;
    height: 1.125rem;
    line-height: 1.125rem;
  }

  .menu3t {
    flex: 0 0 1.25rem;
    display: flex;
    font-size: 0.225rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    opacity: 0.8;
    z-index: 3000;
  }

  .menu3 {
    flex: 0 0 1.625rem;
    display: flex;
    font-size: 0.225rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    opacity: 0.8;

    .menu31 {
      display: flex;
      align-items: center;
      position: relative;
      // flex: 1;
      text-align: center;
      margin-right: 0.0875 * 2rem;
    }

    .menu31:after {
      position: absolute;
      right: -0.0875rem;
      // margin-top: 0.0375rem;
      height: calc(100% - 0.075rem);
      width: 1px;
      height: 0.2rem;
      background: #fff;
      content: "";
    }

    .menu32 {
      // flex: 1;
      text-align: center;
    }
  }

  .menu4 {
    flex: 0 0 0.3rem;
    font-size: 0.225rem;
    color: #ffffff;
    // opacity: 0.8;
    text-align: right;

    /deep/ .el-input__inner {
      width: 3.7375rem;
      height: 0.625rem;
    }

    /deep/ .el-input-group__append {
      width: 0.95rem;
      height: 0.625rem;
      border: none;
      padding: 0;
      background: #ee564f;
      border-radius: 0px 6px 6px 0px;

      .el-button {
        width: 0.95rem;
        height: 0.625rem;
        border: none;
        padding: 0;
        background: #ee564f;
        border-radius: 0px 6px 6px 0px;
        font-size: 0.225rem;
        color: #ffffff;
      }

      .el-button:active {
        box-shadow: inset 0px 0px 1px 1px #b5413b;
      }
    }
  }

  [class*=van-hairline]::after {
    border: none;
  }

  .van-cell::after {
    border: none;
  }

  .van-popup--top {
    position: absolute;
    // top: 0.625rem;
  }

  /deep/ .van-overlay {
    position: absolute;
    // top: 0.625rem!important;
  }

  .popDiagTxt {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 2.575rem;
    height: 0.75rem;
    line-height: 0.75rem;
    text-align: center;
    background: #404247;
    color: #fff;
    border-bottom: 1px solid #535353;
    padding: 0 0.25rem 0 0.5rem;
    box-sizing: border-box;

    a {
      color: #020202;
    }
  }

  .popDiagsubtit {
    font-size: 0.2125rem;
    line-height: 0.5rem;
    font-family: Microsoft YaHei;
    font-weight: 300;
    color: #A19E9E;
    text-align: center;

    a {
      color: #A19E9E;
    }
  }

  .van-cell__title {
    width: calc(100% + 24px);
    height: 0.725rem;
    line-height: 0.725rem;
    font-size: 0.3rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #020202;
    text-align: center;
  }

  .van-cell__right-icon {
    position: absolute;
    right: 0.25rem;
    line-height: 0.725rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/mobileMenu.vue